module.exports = __webpack_public_path__ + "quilt1-level7.9a35d3cb.png";